import React, { useEffect, useState } from "react";
import { Switch } from 'antd';
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Pagination from '@material-ui/lab/Pagination';
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Collapse, Typography, Box } from '@mui/material';
import Search from "@material-ui/icons/Search";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import useAuth from "hooks/useAuth";
import ModalAddRouting from "components/ModalAddRouting/ModalAddRouting";
import CardHeader from "components/Card/CardHeader.js";
import ModalDeleteRouting from "components/ModalDeleteRouting/ModalDeleteRouting";
import ModalRemoveNfRouting from "components/ModalRemoveNfRouting/ModalRemoveNfRouting";
import ModalAddNfRouting from "components/ModalAddNfRouting/ModalAddNfRouting";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import ModalShowNfNotDElivery from "components/ModalShowNfNotDelivery/ModalShowNfNotDelivery";

import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";

const styles = {
    colorCard: {
        color: "#999"
    },
    colorCardWeight: {
        color: "#000",
        fontSize: "20px",
        fontWeight: "bold"
    },
    dropDown: {
        width: "80%"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF",
        },
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
        },
    },
    colorCard: {
        color: "#000",
        marginBottom: "-1em",
        fontSize: "14px",
        textAlign: "center"
    },
    floatRight: {
        float: "right",
    },
    maxwidht: {
        maxWidth: "107%",
    },
    toogleclass: {
        marginTop: "15px",
        marginBottom: "15px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50",
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)",
    },
    zindex: {
        zIndex: "0 !important",
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px",
        display: "flex",
        justifyContent: "center"
    },

    sizeAmount: {
        fontSize: "20px",
    },
    marginFor: {
        minHeight: "8em",
        marginTop: "-10px"
    },
    fontSizeOf: {
        fontSize: "10px",
    },
    marg: {
        float: "left",
    },
    List: {
        border: "1px solid #d9dddd",
    },
    mgTop: {
        marginTop: "12px",
        float: "left",
        position: "relative",
        marginLeft: "3px",
    },
    tp: {
        marginTop: "10px",
    },
    center: {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
};

const useStyles = makeStyles(styles);
const useStyles3 = makeStyles(styles3);

export default function BatchToCar() {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const classes = useStyles();
    const classes3 = useStyles3();

    const { storageId } = useAuth();
    const index = { id: 1 };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [table, setTable] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [totalPages, setTotalPages] = useState(10);
    const [idDeliveryman, setIdDeliveryman] = useState(0);
    const [id_car, setId_car] = useState(0);
    const [cars, setCars] = useState([]);
    const [deliverymans, setDeliverymans] = useState([]);
    const [sells, setSells] = useState([]);
    const [idDelete, setIdDelete] = useState(null);
    const [removeData, setRemoveData] = useState(null);
    const [idRouting, setIdRouting] = useState(null);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalAddRouting, setModalAddRouting] = useState(false)
    const [modalShowRemoveNf, setModalShowRemoveNf] = useState(false);
    const [modalShowAddNf, setModalShowAddNf] = useState(false);
    const [modalShowNfNotDelivery, setModalShowNfNotDelivery] = useState(false);
    const [importModal, setImportModal] = useState(false);
    const [expanded, setExpanded] = useState({});
    const [loading, setLoading] = useState(false);

    const handleToggle = (index) => {
        setExpanded((prevExpanded) => ({
            ...prevExpanded,
            [index]: !prevExpanded[index],
        }));
    };
    useEffect(() => {
        getAllCar();
        loadNf();
        getDeliveryman();
        getAllRoutingToCar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        getAllRoutingToCar();
    }, [page, startDate, endDate, id_car, idDeliveryman, search]);
    const loadModal = async () => {
        setImportModal(true);
    };
    const abrirModal = () => {
        if (!modalAddRouting) {
            loadModal();
        }
        setModalAddRouting(true);
    };
    const openModalDelete = (route) => {
        if (!modalAddRouting) {
            loadModal();
        }
        setModalShowDelete(true);
        setIdDelete(route);
    };
    const openModalNfNotDelivery = (route) => {
        if (!modalShowNfNotDelivery) {
            loadModal();
        }
        setModalShowNfNotDelivery(true);
    };
    const nfButton = (id, nf) => {
        console.log(nf)
        nf.date_of_delivery ? downloadImage(nf.nf) : openModalRemoveNf(id, nf.nf);
    };
    const openModalRemoveNf = (id, nf) => {
        if (!modalAddRouting) {
            loadModal();
        };
        setRemoveData({ id, nf });
        setModalShowRemoveNf(true);
    };
    const downloadImage = (nf) => {
        let link2 = "https://dsaprospectos.com.br/image/" + nf;

        window.open(link2, "_blank")

    }
    const openModalAddNf = (id) => {
        if (!modalAddRouting) {
            loadModal();
        };
        setIdRouting(id)
        setModalShowAddNf(true);
    };
    const loadNf = async () => {
        const response = await api.get(`/routing/not/delivery/${storageId}`);
        if (response.status === 200) {
            setSells(response.data)
        };
    };
    const getAllCar = async () => {
        const data = await api.get(`/car?id=${storageId}&perPage=1000&page=1`);

        let car_admmin = [{ id: 0, model: "TODOS", deliverymanname: "" }];
        for (let i = 0; i < data.data.car.length; i++) {
            car_admmin = [...car_admmin, data.data.car[i]];
        }
        setCars(car_admmin);
    };
    const getDeliveryman = async () => {
        const response = await api.get(`/deliveryman/drop?id=${storageId}&type=admin`);
        let deliveryman = [{ id: 0, deliverymanname: "TODOS" }];
        for (let i = 0; i < response.data.length; i++) {
            deliveryman = [...deliveryman, response.data[i]];
        }
        setDeliverymans(deliveryman);
    };
    const getAllRoutingToCar = async () => {
        try {
            const response = await api.get(`/routing/${storageId}?perPage=${perPage}&page=${page}&initDate=${startDate}&endDate=${endDate}&car=${id_car}&deliveryman=${idDeliveryman}&search=${search}`);
            if (response.status === 200) {
                setTable(response.data.routing);
                setTotalPages(response.data.totalCount)
            };
        } catch (error) {
            return alert(`Nao foi possivel carregar rotas: ${error}`);
        }
    };
    const handleChange = (event, value) => {
        setPage(value);
    };
    const generateReport = async (id_routing, route, short, deliverymanname) => {
        try {
            setLoading(true);
            const response = await api.post('/routing/report', {
                id_admin: storageId,
                id: id_routing,
                short: short
            }, {
                responseType: "blob", // Definido aqui
            }).then(async function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = `Rota-${route}-${deliverymanname}.pdf`;
                link.click();
            }).catch(function (error) {
                console.log(error);
            });
            setLoading(false);
        } catch (error) {
            // return alert(`Nao foi possivel gerar relatorio: ${error}`);
        }
    };
    return (
        <><GridContainer>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Nova Rota</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Button color="success" onClick={() => abrirModal()}>
                            Nova Rota
                        </Button>
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Data Inicio</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <DatePicker
                            className={classes.marginDate}
                            selected={startDate}
                            onChange={(date) => date ? setStartDate(date.withoutTime()) : setStartDate(null)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            disabledKeyboardNavigation
                            locale={pt} />
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Data Final</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <DatePicker
                            className={classes.marginDate}
                            selected={endDate}
                            onChange={(date) => date ? setEndDate(date.withoutTime()) : setEndDate(null)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            disabledKeyboardNavigation
                            locale={pt} />
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Filtrar Carros</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Form.Control onChange={event => setId_car(event.target.value)} value={id_car} as="select" className={classes.dropDown}>
                            {cars.map(car => (
                                <option key={`car_${car.id}`} value={car.id}>{car.model}</option>
                            ))}
                        </Form.Control>
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p className={classes.colorCard}>Filtrar Entregador</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Form.Control onChange={event => setIdDeliveryman(event.target.value)} value={idDeliveryman} as="select" className={classes.dropDown}>
                            {deliverymans.map(deliveryman => (
                                <option key={`del_${deliveryman.id}`} value={deliveryman.id}>{deliveryman.deliverymanname}</option>
                            ))}
                        </Form.Control>
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
                <Card className={classes.marginFor}>
                    <div className="d-flex justify-content-center">
                        <CardBody>
                            <p style={{ color: "#000", fontSize: "14px", textAlign: "center" }} >Pendencias de entregas</p>
                            <p style={{ color: 'red', marginBottom: "-1em", fontSize: "20px", fontWeight: 'bold', textAlign: "center" }} >{sells.total}</p>
                        </CardBody>
                    </div>
                    <div className={classes.marginDate}>
                        <Button color="success" onClick={() => openModalNfNotDelivery()}>
                            Pendencias
                        </Button>
                    </div>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes3.searchWrapper}>
                    <CustomInput
                        formControlProps={{
                            className: classes3.margin + " " + classes3.search
                        }}
                        inputProps={{
                            placeholder: "Nota fiscal, entregador ou carro",
                            inputProps: {
                                "aria-label": "Search",
                                type: "text",
                                value: search,
                                onChange: event => setSearch(event.target.value)
                            }
                        }}
                    />
                    <Button color="white" aria-label="edit" justIcon round>
                        <Search />
                    </Button>
                </div>
            </GridItem>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </GridContainer>
            <Box>
                {table.length > 0 ? table.map((route, index) => (
                    <Card className={classes.test} key={`card_${index}`}>
                        <CardHeader className={classes.zindex} color={"success"}>
                            <div style={{ display: 'flex', justifyContent: "space-between", width: '100%' }}>
                                <h4 className={classes.cardTitleWhite}>
                                    Rota - {route.model} -   {moment(route.created_at).format('DD/MM/YYYY')}
                                </h4>
                                <Tooltip id="tooltip-top-start" title="Deletar" placement="top" >
                                    <IconButton aria-label="Close" onClick={() => openModalDelete(route)} >
                                        <Close style={{ backgroundColor: "transparent", color: "red", boxShadow: "none", }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </CardHeader>
                        <CardBody className={classes.ftsize}>
                            <div style={{ display: 'block', width: '100%' }}>
                                <p style={{ fontWeight: "bold" }}> Numero da rota: <b style={{ fontWeight: "normal" }}>{route.router_controller} </b>  </p>
                            </div>
                            <div style={{ display: 'block', width: '100%' }}>
                                <p style={{ fontWeight: "bold" }}> Entregador: <b style={{ fontWeight: "normal" }}>{route.deliverymanname} </b>  </p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'left', width: '100%' }}>
                                <div style={{ marginRight: '30px' }}>
                                    <Tooltip title="VER NF">
                                        <IconButton onClick={() => handleToggle(index)}>
                                            {expanded[index] ? <ExpandLessIcon sx={{ fontSize: 35 }} /> : <ExpandMoreIcon sx={{ fontSize: 35 }} />}
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div style={{ display: 'flex', gap: '1em', flexDirection: 'row' }}>
                                    <Button color="info" onClick={() => generateReport(route.id, route.route, false, route.deliverymanname)}>
                                        Entrega - {route.route}
                                    </Button>
                                    <Button color="warning" onClick={() => generateReport(route.id, route.route, true, route.deliverymanname)}>
                                        Entrega resumida- {route.route}
                                    </Button>
                                </div>

                            </div>
                            <Collapse in={expanded[index]}>
                                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: '4px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography variant="h6">Notas da rota</Typography>
                                        <Tooltip title="ADICIONAR NF">
                                            <IconButton onClick={() => openModalAddNf(route.id)}>
                                                <AddCircleIcon sx={{ color: 'green' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    {route.nfs ? route.nfs.map((nf) => {
                                        return (
                                            <div style={{ display: 'inline-flex' }} key={`nf_route_${nf.nf}`}>
                                                <Button color={nf.date_of_delivery ? 'success' : 'warning'} onClick={() => nfButton(route.id, nf)}>
                                                    {nf.nf}
                                                </Button>
                                            </div>
                                        )

                                    }) : ""}

                                </Box>
                            </Collapse>

                        </CardBody>
                    </Card>
                ))
                    : ""}

                <Pagination count={totalPages} page={page} onChange={handleChange} />

                {modalShowDelete && importModal && (
                    <ModalDeleteRouting key={String("del_" + index.id)} props={idDelete} show={modalShowDelete} onHide={() => setModalShowDelete(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalShowRemoveNf && importModal && (
                    <ModalRemoveNfRouting key={`remove_nf`} props={removeData} show={modalShowRemoveNf} onHide={() => setModalShowRemoveNf(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalShowAddNf && importModal && (
                    <ModalAddNfRouting key={`add_nf`} props={idRouting} show={modalShowAddNf} onHide={() => setModalShowAddNf(false)} getAllRouting={getAllRoutingToCar} />
                )}
                {modalShowNfNotDelivery && importModal && (
                    <ModalShowNfNotDElivery key={`note_delivery`} props={idRouting} sells={sells.nf_not_delivery} show={modalShowNfNotDelivery} onHide={() => setModalShowNfNotDelivery(false)} />
                )}
                {modalAddRouting && importModal && (
                    <ModalAddRouting
                        key={String("add_" + storageId)}
                        show={modalAddRouting}
                        onHide={() => setModalAddRouting(false)}
                        deliverymans={deliverymans}
                        cars={cars}
                        loadRouting={() => getAllRoutingToCar}
                    />
                )}
            </Box>
        </>
    );
}
